import axios from 'axios';
import config from '../config';
import { fetchAuthSession, signOut, getCurrentUser } from '@aws-amplify/auth';

axios.interceptors.response.use(
  res => {
    return res;
  },
  err => {
    if (
      err.response !== undefined &&
      err.response.status == 401 &&
      err.response.data['authorisationUrl'] !== undefined
    ) {
    }

    throw err;
  }
);


export async function send_request(
  path,
  bodydata,
  querydata,
  method,
  header = { Accept: 'application/json', 'Content-Type': 'application/json' },
  responseType,
  onUploadProgress = null,
  timeoutMs = 28000
) {
  // Normalize path to avoid double slashes (e.g., when path starts with '/')
  let normalizedPath = path.startsWith('/') ? path.slice(1) : path;
  
  // Route database/* and task/* paths through data-service
  // V2 architecture: data-service has context-path /data-service
  if (normalizedPath.startsWith('database/') || normalizedPath.startsWith('task/')) {
    normalizedPath = `data-service/${normalizedPath}`;
  }
  
  let url = `${config.API_ADDRESS}/${normalizedPath}`;

  if (querydata) {
    url = url + '?' + serializeData(querydata);
  }
  try {
    const { tokens } = await fetchAuthSession();
    const user = await getCurrentUser();
    header['Authorization'] = `Bearer ${tokens.idToken.toString()}`;
    header['user-id'] = user.username;
    const request = await axios(url, {
      method: method,
      data: bodydata,
      headers: header,
      responseType: responseType,
      onUploadProgress,
      timeout: timeoutMs,
    })
      .then(
        res => {
          return res;
        },
        rej => {
          throw rej;
        }
      )
      .catch(async error => {
        throw error;
      });
    return request;
  } catch (err) {
    if (err === 'No current user' || (err.code && err.code === 'NotAuthorizedException')) {
      //In case no user found exception is thrown
      await signOut();
      window.location.pathname = '/';
    }
    return err;
  }
}

/**
 * Function used for performing the component save query
 * for individual component templates
 *
 * Here, you are able to attach additional data to the payload
 * in one location
 */
export const send_component_save_request = async (
  path,
  bodydata,
  querydata,
  method,
  saveTrigger
) => {

  let data = null; // Init data object

  // If we're given the bodydata, copy the properties over
  if (bodydata) {
    data = {
      ...bodydata,
    };
  }

  // Handle data manipulation here
  if (saveTrigger) {
    if (saveTrigger.sessionId) {
      data['sessionId'] = saveTrigger.sessionId; // Add the session id to the data map
      delete saveTrigger['sessionId']; // Remove it from the save trigger
    }
  }

  return send_request(path, data, querydata, method).then(res => {
    return res;
  }).catch(err => {
    throw err;
  });
};

export async function send_request_without_auth(
  path,
  bodydata,
  querydata,
  method,
  header = { Accept: 'application/json', 'Content-Type': 'application/json' },
  responseType
) {
  let normalizedPath = path.startsWith('/') ? path.slice(1) : path;
  
  // Route database/* and task/* paths through data-service
  // V2 architecture: data-service has context-path /data-service
  if (normalizedPath.startsWith('database/') || normalizedPath.startsWith('task/')) {
    normalizedPath = `data-service/${normalizedPath}`;
  }
  
  let url = `${config.API_ADDRESS}/${normalizedPath}`;

  if (querydata) {
    url = url + '?' + serializeData(querydata);
  }
  const request = await axios(url, {
    method: method,
    data: bodydata,
    headers: header,
    responseType: responseType,
  })
    .then(
      res => {
        return res;
      },
      rej => {
        console.log(rej);
        throw rej;
        // return rej;
      }
    )
    .catch(error => {
      throw error;
    });
  return request;
}

export async function send_request_optional_auth(
  path,
  bodydata,
  querydata,
  method,
  header = { Accept: 'application/json', 'Content-Type': 'application/json' },
  responseType
) {
  let normalizedPath = path.startsWith('/') ? path.slice(1) : path;

  // Route database/* and task/* paths through data-service
  // V2 architecture: data-service has context-path /data-service
  if (normalizedPath.startsWith('database/') || normalizedPath.startsWith('task/')) {
    normalizedPath = `data-service/${normalizedPath}`;
  }

  let url = `${config.API_ADDRESS}/${normalizedPath}`;

  if (querydata) {
    url = url + '?' + serializeData(querydata);
  }

  const requestHeaders = { ...header };
  try {
    const { tokens } = await fetchAuthSession();
    const user = await getCurrentUser();
    if (tokens?.idToken && user?.username) {
      requestHeaders['Authorization'] = `Bearer ${tokens.idToken.toString()}`;
      requestHeaders['user-id'] = user.username;
    }
  } catch (_err) {
    // Intentionally continue as anonymous for public-link access.
  }

  const request = await axios(url, {
    method: method,
    data: bodydata,
    headers: requestHeaders,
    responseType: responseType,
  })
    .then(
      res => {
        return res;
      },
      rej => {
        console.log(rej);
        throw rej;
      }
    )
    .catch(error => {
      throw error;
    });
  return request;
}

export async function send_external_request(
  path,
  bodydata,
  querydata,
  method,
  header = { Accept: 'application/json', 'Content-Type': 'application/json' }
) {
  let url = `${path}`;

  if (querydata) {
    url = url + serializeData(querydata);
  }

  const request = axios(url, {
    method: method,
    data: bodydata,
    headers: header,
  })
    .then(res => {
      return res;
    })
    .catch(error => {
      throw error;
    });
  return request;
}

function serializeData(formBodyObj) {
  const requestBody = Object.keys(formBodyObj)
    .map(key => {
      return encodeURIComponent(key) + '=' + encodeURIComponent(formBodyObj[key]);
    })
    .join('&');

  return requestBody;
}
